import {
  NEWS_CATEGORY_REQUEST,
  NEWS_CATEGORY_FAILURE,
  FETCH_NEWS_CATEGORIES_SUCCESS,
  CREATE_NEWS_CATEGORY_SUCCESS,
  DELETE_NEWS_CATEGORY_SUCCESS,
  UPDATE_NEWS_CATEGORY_SUCCESS,
  GET_NEWS_CATEGORY_SUCCESS,
} from "../action/types";

const initialState = {
  categories: [],
  currentCategory: null,
  loading: false,
  error: null,
};

const newsCategoryReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case NEWS_CATEGORY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case FETCH_NEWS_CATEGORIES_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: payload?.data ?? (Array.isArray(payload) ? payload : []),
      };

    case GET_NEWS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        currentCategory: payload,
        categories: state.categories.map((cat) =>
          cat.id === payload?.id ? payload : cat,
        ),
      };

    case CREATE_NEWS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: [...state.categories, payload],
      };

    case UPDATE_NEWS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.map((cat) =>
          (cat.id || cat._id) === (payload?.id || payload?._id) ? payload : cat,
        ),
      };

    case DELETE_NEWS_CATEGORY_SUCCESS:
      return {
        ...state,
        loading: false,
        categories: state.categories.filter((cat) => cat.id !== payload),
      };

    case NEWS_CATEGORY_FAILURE:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};

export default newsCategoryReducer;
